import { Session } from './solidOidcAdapter'

export const authSession = new Session()
